'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bestPageUrlFor = exports.bestDomainFor = undefined;

var _Foursquare = require('./Foursquare');

var Foursquare = _interopRequireWildcard(_Foursquare);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var bestDomainFor = exports.bestDomainFor = function bestDomainFor(locale) {
	var language = locale.substr(0, 2);
	var languageDomain = Foursquare.languageDomains[language];
	if (languageDomain) {
		return languageDomain;
	}

	return Foursquare.languageDomains['en'];
};

var bestPageUrlFor = exports.bestPageUrlFor = function bestPageUrlFor(_ref) {
	var locale = _ref.locale,
	    venueId = _ref.venueId,
	    tab = _ref.tab;

	var language = locale.substr(0, 2);
	var domain = Foursquare.languageDomains[language];
	if (domain) {
		return !tab ? 'https://' + domain + '/v/' + venueId : 'https://' + domain + '/v/' + venueId + '/' + tab;
	} else {
		return !tab ? 'https://' + Foursquare.languageDomains['en'] + '/v/' + venueId + '?locale=' + language : 'https://' + Foursquare.languageDomains['en'] + '/v/' + venueId + '/' + tab + '?locale=' + language;
	}
};